module.exports = __webpack_public_path__ + "static/media/logo_cappellini.5f592cea.svg";